"use strict";

var _regeneratorRuntime = require("/opt/buildhome/repo/node_modules/@babel/runtime/regenerator/index.js");

var _slicedToArray = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _asyncToGenerator = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contextRandomize = exports.ecdh = exports.signatureNormalize = exports.signatureImport = exports.signatureExport = exports.privateKeyTweakMul = exports.publicKeyTweakMul = exports.publicKeyTweakAdd = exports.publicKeyCombine = exports.publicKeyNegate = exports.privateKeyNegate = exports.privateKeyTweakAdd = exports.ecdsaVerify = exports.ecdsaRecover = exports.ecdsaSign = exports.publicKeyConvert = exports.publicKeyVerify = exports.publicKeyCreate = exports.privateKeyVerify = exports.createPrivateKey = exports.createPrivateKeySync = void 0;

var sha256_1 = require("@noble/hashes/sha256");

var secp = __importStar(require("./secp256k1"));

var utils_1 = require("./utils"); // Use `secp256k1` module directly.
// This is a legacy compatibility layer for the npm package `secp256k1` via noble-secp256k1


function hexToNumber(hex) {
  if (typeof hex !== "string") {
    throw new TypeError("hexToNumber: expected string, got " + typeof hex);
  }

  return BigInt("0x".concat(hex));
} // Copy-paste from secp256k1, maybe export it?


var bytesToNumber = function bytesToNumber(bytes) {
  return hexToNumber((0, utils_1.toHex)(bytes));
};

var numberToHex = function numberToHex(num) {
  return num.toString(16).padStart(64, "0");
};

var numberToBytes = function numberToBytes(num) {
  return (0, utils_1.hexToBytes)(numberToHex(num));
};

var mod = secp.utils.mod;
var ORDER = secp.CURVE.n;

function output() {
  var out = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (len) {
    return new Uint8Array(len);
  };
  var length = arguments.length > 1 ? arguments[1] : undefined;
  var value = arguments.length > 2 ? arguments[2] : undefined;

  if (typeof out === "function") {
    out = out(length);
  }

  (0, utils_1.assertBytes)(out, length);

  if (value) {
    out.set(value);
  }

  return out;
}

function getSignature(signature) {
  (0, utils_1.assertBytes)(signature, 64);
  return secp.Signature.fromCompact(signature);
}

function createPrivateKeySync() {
  return secp.utils.randomPrivateKey();
}

exports.createPrivateKeySync = createPrivateKeySync;

function createPrivateKey() {
  return _createPrivateKey.apply(this, arguments);
}

function _createPrivateKey() {
  _createPrivateKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", createPrivateKeySync());

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _createPrivateKey.apply(this, arguments);
}

exports.createPrivateKey = createPrivateKey;

function privateKeyVerify(privateKey) {
  (0, utils_1.assertBytes)(privateKey, 32);
  return secp.utils.isValidPrivateKey(privateKey);
}

exports.privateKeyVerify = privateKeyVerify;

function publicKeyCreate(privateKey) {
  var compressed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var out = arguments.length > 2 ? arguments[2] : undefined;
  (0, utils_1.assertBytes)(privateKey, 32);
  (0, utils_1.assertBool)(compressed);
  var res = secp.getPublicKey(privateKey, compressed);
  return output(out, compressed ? 33 : 65, res);
}

exports.publicKeyCreate = publicKeyCreate;

function publicKeyVerify(publicKey) {
  (0, utils_1.assertBytes)(publicKey, 33, 65);

  try {
    secp.Point.fromHex(publicKey);
    return true;
  } catch (e) {
    return false;
  }
}

exports.publicKeyVerify = publicKeyVerify;

function publicKeyConvert(publicKey) {
  var compressed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var out = arguments.length > 2 ? arguments[2] : undefined;
  (0, utils_1.assertBytes)(publicKey, 33, 65);
  (0, utils_1.assertBool)(compressed);
  var res = secp.Point.fromHex(publicKey).toRawBytes(compressed);
  return output(out, compressed ? 33 : 65, res);
}

exports.publicKeyConvert = publicKeyConvert;

function ecdsaSign(msgHash, privateKey) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    noncefn: undefined,
    data: undefined
  };
  var out = arguments.length > 3 ? arguments[3] : undefined;
  (0, utils_1.assertBytes)(msgHash, 32);
  (0, utils_1.assertBytes)(privateKey, 32);

  if (typeof options !== "object" || options === null) {
    throw new TypeError("secp256k1.ecdsaSign: options should be object");
  } // noble-secp256k1 uses hmac instead of hmac-drbg here


  if (options && (options.noncefn !== undefined || options.data !== undefined)) {
    throw new Error("Secp256k1: noncefn && data is unsupported");
  }

  var _secp$signSync = secp.signSync(msgHash, privateKey, {
    recovered: true,
    der: false
  }),
      _secp$signSync2 = _slicedToArray(_secp$signSync, 2),
      signature = _secp$signSync2[0],
      recid = _secp$signSync2[1];

  return {
    signature: output(out, 64, signature),
    recid: recid
  };
}

exports.ecdsaSign = ecdsaSign;

function ecdsaRecover(signature, recid, msgHash) {
  var compressed = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var out = arguments.length > 4 ? arguments[4] : undefined;
  (0, utils_1.assertBytes)(msgHash, 32);
  (0, utils_1.assertBool)(compressed);
  var sign = getSignature(signature).toHex();
  var point = secp.Point.fromSignature(msgHash, sign, recid);
  return output(out, compressed ? 33 : 65, point.toRawBytes(compressed));
}

exports.ecdsaRecover = ecdsaRecover;

function ecdsaVerify(signature, msgHash, publicKey) {
  (0, utils_1.assertBytes)(signature, 64);
  (0, utils_1.assertBytes)(msgHash, 32);
  (0, utils_1.assertBytes)(publicKey, 33, 65);
  (0, utils_1.assertBytes)(signature, 64);
  var r = bytesToNumber(signature.slice(0, 32));
  var s = bytesToNumber(signature.slice(32, 64));

  if (r >= ORDER || s >= ORDER) {
    throw new Error("Cannot parse signature");
  }

  var pub = secp.Point.fromHex(publicKey); // should not throw error

  var sig;

  try {
    sig = getSignature(signature);
  } catch (error) {
    return false;
  }

  return secp.verify(sig, msgHash, pub);
}

exports.ecdsaVerify = ecdsaVerify;

function privateKeyTweakAdd(privateKey, tweak) {
  (0, utils_1.assertBytes)(privateKey, 32);
  (0, utils_1.assertBytes)(tweak, 32);
  var t = bytesToNumber(tweak);

  if (t === 0n) {
    throw new Error("Tweak must not be zero");
  }

  if (t >= ORDER) {
    throw new Error("Tweak bigger than curve order");
  }

  t += bytesToNumber(privateKey);

  if (t >= ORDER) {
    t -= ORDER;
  }

  if (t === 0n) {
    throw new Error("The tweak was out of range or the resulted private key is invalid");
  }

  privateKey.set((0, utils_1.hexToBytes)(numberToHex(t)));
  return privateKey;
}

exports.privateKeyTweakAdd = privateKeyTweakAdd;

function privateKeyNegate(privateKey) {
  (0, utils_1.assertBytes)(privateKey, 32);
  var bn = mod(-bytesToNumber(privateKey), ORDER);
  privateKey.set((0, utils_1.hexToBytes)(numberToHex(bn)));
  return privateKey;
}

exports.privateKeyNegate = privateKeyNegate;

function publicKeyNegate(publicKey) {
  var compressed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var out = arguments.length > 2 ? arguments[2] : undefined;
  (0, utils_1.assertBytes)(publicKey, 33, 65);
  (0, utils_1.assertBool)(compressed);
  var point = secp.Point.fromHex(publicKey).negate();
  return output(out, compressed ? 33 : 65, point.toRawBytes(compressed));
}

exports.publicKeyNegate = publicKeyNegate;

function publicKeyCombine(publicKeys) {
  var compressed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var out = arguments.length > 2 ? arguments[2] : undefined;

  if (!Array.isArray(publicKeys) || !publicKeys.length) {
    throw new TypeError("Expected array with one or more items, not ".concat(publicKeys));
  }

  var _iterator = _createForOfIteratorHelper(publicKeys),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var publicKey = _step.value;
      (0, utils_1.assertBytes)(publicKey, 33, 65);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  (0, utils_1.assertBool)(compressed);
  var combined = publicKeys.map(function (pub) {
    return secp.Point.fromHex(pub);
  }).reduce(function (res, curr) {
    return res.add(curr);
  }, secp.Point.ZERO); // Prohibit returning ZERO point

  if (combined.equals(secp.Point.ZERO)) {
    throw new Error("Combined result must not be zero");
  }

  return output(out, compressed ? 33 : 65, combined.toRawBytes(compressed));
}

exports.publicKeyCombine = publicKeyCombine;

function publicKeyTweakAdd(publicKey, tweak) {
  var compressed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var out = arguments.length > 3 ? arguments[3] : undefined;
  (0, utils_1.assertBytes)(publicKey, 33, 65);
  (0, utils_1.assertBytes)(tweak, 32);
  (0, utils_1.assertBool)(compressed);
  var p1 = secp.Point.fromHex(publicKey);
  var p2 = secp.Point.fromPrivateKey(tweak);
  var point = p1.add(p2);

  if (p2.equals(secp.Point.ZERO) || point.equals(secp.Point.ZERO)) {
    throw new Error("Tweak must not be zero");
  }

  return output(out, compressed ? 33 : 65, point.toRawBytes(compressed));
}

exports.publicKeyTweakAdd = publicKeyTweakAdd;

function publicKeyTweakMul(publicKey, tweak) {
  var compressed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var out = arguments.length > 3 ? arguments[3] : undefined;
  (0, utils_1.assertBytes)(publicKey, 33, 65);
  (0, utils_1.assertBytes)(tweak, 32);
  (0, utils_1.assertBool)(compressed);
  var bn = bytesToNumber(tweak);

  if (bn === 0n) {
    throw new Error("Tweak must not be zero");
  }

  if (bn <= 1 || bn >= ORDER) {
    throw new Error("Tweak is zero or bigger than curve order");
  }

  var point = secp.Point.fromHex(publicKey).multiply(bn);
  return output(out, compressed ? 33 : 65, point.toRawBytes(compressed));
}

exports.publicKeyTweakMul = publicKeyTweakMul;

function privateKeyTweakMul(privateKey, tweak) {
  (0, utils_1.assertBytes)(privateKey, 32);
  (0, utils_1.assertBytes)(tweak, 32);
  var bn = bytesToNumber(tweak);

  if (bn <= 1 || bn >= ORDER) {
    throw new Error("Tweak is zero or bigger than curve order");
  }

  var res = mod(bn * bytesToNumber(privateKey), ORDER);

  if (res === 0n) {
    throw new Error("The tweak was out of range or the resulted private key is invalid");
  }

  privateKey.set((0, utils_1.hexToBytes)(numberToHex(res)));
  return privateKey;
}

exports.privateKeyTweakMul = privateKeyTweakMul; // internal -> DER

function signatureExport(signature, out) {
  var res = getSignature(signature).toRawBytes();
  return output(out, 72, getSignature(signature).toRawBytes()).slice(0, res.length);
}

exports.signatureExport = signatureExport; // DER -> internal

function signatureImport(signature, out) {
  (0, utils_1.assertBytes)(signature);
  var sig = secp.Signature.fromDER(signature);
  return output(out, 64, (0, utils_1.hexToBytes)(sig.toCompactHex()));
}

exports.signatureImport = signatureImport;

function signatureNormalize(signature) {
  var res = getSignature(signature);

  if (res.s > ORDER / 2n) {
    signature.set(numberToBytes(ORDER - res.s), 32);
  }

  return signature;
}

exports.signatureNormalize = signatureNormalize;

function ecdh(publicKey, privateKey) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var out = arguments.length > 3 ? arguments[3] : undefined;
  (0, utils_1.assertBytes)(publicKey, 33, 65);
  (0, utils_1.assertBytes)(privateKey, 32);

  if (typeof options !== "object" || options === null) {
    throw new TypeError("secp256k1.ecdh: options should be object");
  }

  if (options.data !== undefined) {
    (0, utils_1.assertBytes)(options.data);
  }

  var point = secp.Point.fromHex(secp.getSharedSecret(privateKey, publicKey));

  if (options.hashfn === undefined) {
    return output(out, 32, (0, sha256_1.sha256)(point.toRawBytes(true)));
  }

  if (typeof options.hashfn !== "function") {
    throw new TypeError("secp256k1.ecdh: options.hashfn should be function");
  }

  if (options.xbuf !== undefined) {
    (0, utils_1.assertBytes)(options.xbuf, 32);
  }

  if (options.ybuf !== undefined) {
    (0, utils_1.assertBytes)(options.ybuf, 32);
  }

  (0, utils_1.assertBytes)(out, 32);
  var xbuf = options.xbuf || new Uint8Array(32);
  xbuf.set(numberToBytes(point.x));
  var ybuf = options.ybuf || new Uint8Array(32);
  ybuf.set(numberToBytes(point.y));
  var hash = options.hashfn(xbuf, ybuf, options.data);

  if (!(hash instanceof Uint8Array) || hash.length !== 32) {
    throw new Error("secp256k1.ecdh: invalid options.hashfn output");
  }

  return output(out, 32, hash);
}

exports.ecdh = ecdh;

function contextRandomize(seed) {
  if (seed !== null) {
    (0, utils_1.assertBytes)(seed, 32);
  } // There is no context to randomize

}

exports.contextRandomize = contextRandomize;